import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../../firebaseconfig';
import './AuthRedirect.css';

const AuthRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [status, setStatus] = useState('Autenticando, por favor aguarde...');

    useEffect(() => {
        // Simplificado para BrowserRouter: usa só location.search (sem hash fallback)
        const timer = setTimeout(() => {
            const loginWithToken = async () => {
                let params;
                
                if (location.search) {
                    params = new URLSearchParams(location.search);
                } else {
                    setStatus('Erro: Parâmetros de autenticação não encontrados. Redirecionando...');
                    setTimeout(() => navigate('/login'), 3000);
                    return;
                }

                const token = params.get('token');
                const appKey = params.get('appKey');
                const fromApp = params.get('from_app');

                if (!token || !appKey) {
                    setStatus('Erro: Token ou App não especificado. Redirecionando...');
                    setTimeout(() => navigate('/login'), 3000);
                    return;
                }

                try {
                    await signInWithCustomToken(auth, token);
                    navigate(`/planos/${appKey}?from_app=${fromApp}`);
                } catch (error) {
                    console.error("Erro ao autenticar com token:", error);
                    setStatus('Erro na autenticação. Redirecionando para o login...');
                    setTimeout(() => navigate('/login'), 3000);
                }
            };

            loginWithToken();
        }, 100); // Mantido o delay para timing de auth

        return () => clearTimeout(timer);

    }, [navigate, location]);

    return (
        <div className="auth-redirect-container">
            <div className="auth-redirect-spinner"></div>
            <p>{status}</p>
        </div>
    );
};

export default AuthRedirect;